import { CompanyVerbiage } from '../companyVerbiage'
import { scanaVerbiage } from '../scana/scana-verbiage'

//Scana regulated overrides
export const scanaRegulatedVerbiage: CompanyVerbiage = {
    ...scanaVerbiage,
}
